import { deleteField, doc, writeBatch } from "firebase/firestore";
import { firestore } from "../../firebase/config";

const deleteSchedule = async (tournamentId, teams) => {
  const batch = writeBatch(firestore);
  const schedulesRef = doc(firestore, "schedules", tournamentId);
  const tournamentRef = doc(firestore, "tournaments", tournamentId);

  batch.update(tournamentRef, {
    schedule: deleteField(),
    scheduleTimes: deleteField(),
    scheduleType: deleteField(),
  });

  batch.delete(schedulesRef);

  try {
    await batch.commit();
  } catch (error) {
    console.log(error);
    alert(error.message);
  }

  window.location.reload();
};

export default deleteSchedule;
